import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { ROUTE_DENIED } from 'constants/routerPath';

const ADMIN_GROUP_NAMES = ['SDS_Admin'];

interface UserRoleGroup {
  id: string;
  name: string;
}

function useInstanceSettingsAccess() {
  const { userInfo } = useSelector(selectUserInfo);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (!userInfo.contactId) return;

    const hasAdminGroup = userInfo.userRoleGroups?.some(
      (group: UserRoleGroup) => ADMIN_GROUP_NAMES.includes(group.name),
    );

    const isAllowed = Boolean(hasAdminGroup);

    if (!isAllowed) {
      navigate(ROUTE_DENIED);
    }

    setIsAdmin(isAllowed);
    setIsChecked(true);
  }, [navigate, userInfo]);

  return { isAdmin, isChecked };
}

export default useInstanceSettingsAccess;
